import { Color } from '../../../styles/Color';
import { theme } from '../../../styles/theme';
import { Responsive } from '../../../ui';

export const NavigationItemFont = `
	font-family: inherit;
	font-size: ${theme.typography?.body?.size};
	font-weight: 400;

	@media (${Responsive.getMediaQueryForBreakpoint('desktop')}) {
		font-weight: 500;
	}
`;

export const MainNavigationItemCommon = `
	${NavigationItemFont}
	display: inline-block;

	&:hover {
		color: ${Color.OnBackgroundText};
		text-decoration: none;
	}
	

	@media (${Responsive.getMediaQueryForBreakpoint('desktop')}) {
		width: 100%;
		justify-content: space-between;
		color: ${Color.OnBackgroundText2};
	}

`;

export const SubMenuNavItemCommon = `
	${NavigationItemFont}
	display: inline-block;
`;

export const getNavigationItemColor = (
	isActive: boolean,
	isSubmenuOpen: boolean,
) => {
	if (!isSubmenuOpen) {
		return `color: ${Color.PrimaryWhite};`;
	}
	if (isActive) {
		return `color: ${Color.OnBackgroundText};`;
	}
	return `color: ${Color.Neutral};`;
};
